export default {
    api_ajax : process.env.VUE_APP_API_URI,
    api_key : process.env.VUE_APP_API_KEY,
    recaptcha_key : process.env.VUE_APP_RECAPTCHA_KEY,
    download_path : process.env.VUE_APP_DOWNLOAD_PATH,
    single_parent_affidavit : 'affidavit_single_parent_labor_ministry.pdf'
}